import React from "react";
import { withStyles } from '@material-ui/core/styles';
import {Switch} from "@material-ui/core"
import { starFishColor } from '../components/styles'

const PrimarySwitch = withStyles((theme) => ({
    root: {
        width: 42,
        height: 18,
        padding: 0,
        overflow: 'visible',
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        top: -4,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                ...starFishColor(theme, "backgroundColor"),
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            ...starFishColor(theme, "backgroundColor"),
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default PrimarySwitch